<template>
  <transition name="fade">
    <router-view />
  </transition>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {}
  },
  computed: {
    websiteConfig: {
      get () {
        return this.$store.state.common.websiteConfig
      },
      set (val) {
        this.$store.commit('common/updateWebsiteConfig', val)
      }
    },
    localeLang: {
      get () { return this.$store.state.common.localeLang },
      set (val) { this.$store.commit('common/updateLocaleLang', val) }
    }
  },
  mounted () {
    this.localeLang = localStorage.getItem('locale') || 'zh'
    this.$i18n.locale = this.localeLang
    this.getWebset()
  },
  methods: {
    getWebset () {
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/websiteConfig/list'),
        method: 'post',
        data: {
          isPage: false,
        }
      }).then((res) => {
        if (res.data && res.data.code === 'C0000') {
          let array = res.data.result.list || []
          let object = {}
          array.forEach(el => {
            object[el.configKey] = el.configValue
          })
          this.websiteConfig = {...object}
        } else {
          this.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue